import { makeStyles } from "@material-ui/core";


export default makeStyles(theme => ({
    body: {
        borderTop: "none",
        border: `1px solid ${theme.palette.grey[300]}`,
    },
    cell: {
        "&:first-child div": {
            color: theme.palette.grey[700],
            fontFamily: "source sans pro",
            fontSize: 16,
            fontWeight: 600,
        },
        "&:nth-child(2) div": {
            fontWeight: 400,
        },
    },
    container: {
        flexGrow: 1,
    },
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.grey[900],
        // border won't follow sticky header
        boxShadow: `inset 0 1px 0 ${theme.palette.grey[300]}, inset 0 -1px 0 ${theme.palette.grey[700]}`,
        "& th": {
            fontFamily: "source sans pro",
            fontSize: 14,
            fontWeight: 600,
            textTransform: "uppercase",
            color: theme.palette.grey[900],
        },
    },
    location: {
        fontSize: 16,
        color: theme.palette.grey[700],
    },
    root: {
        backgroundColor: theme.palette.grey[100],
        padding: "2em 3em",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
    },
    row: {
        height: 120,
        fontWeight: 600,
        fontSize: 16,
        color: theme.palette.grey[700],
        "&:hover": {
            cursor: "pointer",
        },
    },
    table: {
        borderCollapse: "separate",
        backgroundColor: theme.palette.common.white,
        borderTop: "none",
        border: `1px solid ${theme.palette.grey[300]}`,
    },
    tablePrefix: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        marginBottom: 16,
    },
    title: {
        fontFamily: "Source Sans Pro",
        fontSize: 24,
        fontWeight: 600,
        color: theme.palette.grey[900],
    },
}));
